"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.initSrollbarSimplebarAndMouseHandler = initSrollbarSimplebarAndMouseHandler;
/** Предостережения: https://github.com/Grsmto/simplebar/tree/master/packages/simplebar#5-caveats */
const scrollbar_1 = require("./scrollbar");
const resize_observer_polyfill_1 = __importDefault(require("resize-observer-polyfill"));
window.ResizeObserver = resize_observer_polyfill_1.default;
const SELECTOR = '.scrollbar-simplebar';
function initSrollbarSimplebarAndMouseHandler() {
    const elements = document.querySelectorAll(SELECTOR);
    if (elements.length === 0) {
        console.warn('Элементы с селектором .scrollbar-simplebar не найдены');
        return;
    }
    // Динамический импорт только при наличии элементов
    Promise.resolve().then(() => __importStar(require('simplebar'))).then((_a) => __awaiter(this, [_a], void 0, function* ({ default: SimpleBar }) {
        elements.forEach(($scrollableElement, index) => {
            try {
                if (!($scrollableElement instanceof HTMLElement)) {
                    // eslint-disable-next-line no-console
                    console.warn(`Элемент ${index} не является HTMLElement:`, $scrollableElement);
                    return;
                }
                const sizeMaxAttr = $scrollableElement.getAttribute('data-size-max');
                const sizeMax = Number(sizeMaxAttr) || 0;
                if (Number.isNaN(sizeMax) || sizeMax < 0) {
                    // eslint-disable-next-line no-console
                    console.warn(`Некорректное значение data-size-max: ${sizeMaxAttr}`);
                    return;
                }
                const simplebarInstance = new SimpleBar($scrollableElement, {
                    scrollbarMaxSize: sizeMax,
                    tabIndex: 0,
                });
                if (!simplebarInstance.contentWrapperEl) {
                    // console.warn(`contentWrapperEl не определён для SimpleBar на элементе ${index}`);
                    return;
                }
                (0, scrollbar_1.initSrollbarMouseHandler)(simplebarInstance.contentWrapperEl);
            }
            catch (error) {
                // eslint-disable-next-line no-console
                console.warn(`Ошибка при инициализации SimpleBar для элемента ${index}:`, error);
            }
        });
    }))
        .catch(error => {
        // eslint-disable-next-line no-console
        console.warn('Ошибка при загрузке SimpleBar:', error);
    });
}
